export const CookieBar = (function () {
	'use strict';

    var buttonId = '#cookie-understand';
    var cookieName = 'accepted_cookies';
    var cookieValue = 'true';
    var cookieExpire = 365;

	function init() {
        let $bar = $('.cookie-bar');
        if($bar.length > 0){ 
            $(buttonId).on('click', function() {
                if ($.cookie(cookieName) == null){
                    // Create the cookie.
                    $.cookie(cookieName, cookieValue, { expires: cookieExpire, path: '/' });
                    $('.cookie-bar').removeClass('cookie-bar--active');
                }
            });
            // checkCookie();
        }
	}

	// If no cookie, show the cookie bar.
    // function checkCookie(){
    //     if ($.cookie(cookieName) == null) {
    //         // No cookie = Show cookie bar
    //         $('.cookie-bar').addClass('cookie-bar--active');
    //     }
    // }

	return {
		init: init,
	};
})();
